import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import Input from '../../atoms/input/input';
import Select from '../../atoms/select/select';
import './where-confirmation.scss';

const WhereConfirmation = (props) => {
  const { contentInfo, register, setValue, errors, gigyaContext } = props;

  return (
    <div className="m-where">
      <div className="m-where__headings">
        <h2 className="m-where__headings__title">
          {contentInfo && contentInfo.nombre ? contentInfo.nombre : 'Datos de contacto'}
        </h2>
        <div className="m-where__headings__subtitle">
          {contentInfo && documentToReactComponents(JSON.parse(contentInfo.descripcion.raw))}
        </div>
      </div>
      <div className="m-where__content">
        {!gigyaContext?.gigyaAccount && (
          <>
            <div className="m-where__content__input">
              <Input
                label={
                  contentInfo.referencias[0].nombre
                    ? contentInfo.referencias[0].nombre
                    : 'Nombre(s)'
                }
                name="name"
                maxLength="100"
                type="text"
                square
                placeholder={
                  contentInfo.referencias[0].subtitulo
                    ? contentInfo.referencias[0].subtitulo
                    : 'Escribe tu nombre'
                }
                register={register}
                validationRules={{
                  required: {
                    value: true,
                    message: 'Campo requerido',
                  },
                  pattern: {
                    value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                    message: 'No se permiten caracteres especiales',
                  },
                  minLength: {
                    value: 2,
                    message: 'El nombre debe tener al menos 2 caracteres',
                  },
                }}
                setValue={setValue}
                required
                onTypeValidation
                error={errors.name}
              />
            </div>
            <div className="m-where__content__input">
              <Input
                label={
                  contentInfo.referencias[1].nombre
                    ? contentInfo.referencias[1].nombre
                    : 'Apellido(s)'
                }
                name="lastname"
                maxLength="100"
                type="text"
                square
                placeholder={
                  contentInfo.referencias[1].subtitulo
                    ? contentInfo.referencias[1].subtitulo
                    : 'Escribe tu nombre'
                }
                register={register}
                validationRules={{
                  required: {
                    value: true,
                    message: 'Campo requerido',
                  },
                  pattern: {
                    value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                    message: 'No se permiten caracteres especiales',
                  },
                  minLength: {
                    value: 2,
                    message: 'El nombre debe tener al menos 2 caracteres',
                  },
                }}
                setValue={setValue}
                required
                onTypeValidation
                error={errors.lastname}
              />
            </div>
            {contentInfo.referencias && contentInfo.referencias[2] && (
              <div className="m-where__content__input">
                <Select
                  label="Tipo de documento"
                  name="resumeDocumentType"
                  id="m-where__content__input-resume-document-type"
                  register={register}
                  options={
                    contentInfo.referencias[2].listaJson
                      ? contentInfo.referencias[2].listaJson
                      : [
                          {
                            name:
                              contentInfo.referencias &&
                              contentInfo.referencias[2] &&
                              contentInfo.referencias[2].subtitulo
                                ? contentInfo.referencias[2].subtitulo
                                : 'Selecciona un tipo de documento',
                            value: '',
                          },
                        ]
                  }
                  setValue={setValue}
                  square
                  validationRules={{
                    required: {
                      value: true,
                      message: 'Campo requerido',
                    },
                  }}
                  // defaultValue={
                  //     {
                  //         name: (contentInfo.referencias && contentInfo.referencias[1] && contentInfo.referencias[1].subtitulo) ? contentInfo.referencias[1].subtitulo : "Selecciona un tipo de documento",
                  //         value: ""
                  //     }
                  // }
                  error={errors.resumeDocumentType}
                  required
                />
              </div>
            )}
            <div className="m-where__content__input">
              <Input
                label={
                  contentInfo.referencias && contentInfo.referencias[3].nombre
                    ? contentInfo.referencias[3].nombre
                    : 'Número de documento'
                }
                name="document"
                maxLength="25"
                type="number"
                square
                placeholder={
                  contentInfo.referencias && contentInfo.referencias[3].subtitulo
                    ? contentInfo.referencias[3].subtitulo
                    : 'Escribe tu número de documento'
                }
                register={register}
                validationRules={{
                  required: {
                    value: true,
                    message: 'Campo requerido',
                  },
                  pattern: {
                    value: /^[{0-9}]+$/,
                    message: 'No se permiten caracteres especiales',
                  },
                  maxLength: {
                    value: 25,
                    message: 'El documento no debe superar los 25 dígitos',
                  },
                  minLength: {
                    value: 5,
                    message: 'El documento debe tener al menos 5 dígitos',
                  },
                }}
                onTypeValidation
                setValue={setValue}
                required
                error={errors.document}
              />
            </div>
          </>
        )}
        <div className="m-where__content__input">
          <Input
            label={contentInfo.referencias[4].nombre}
            name="email"
            maxLength="50"
            type="email"
            placeholder={contentInfo.referencias[4].subtitulo}
            register={register}
            square
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Debe cumplir con la estructura de un correo',
              },
              maxLength: {
                value: 50,
                message: 'El correo no debe superar los 50 dígitos',
              },
              minLength: {
                value: 4,
                message: 'El correo debe tener al menos 4 dígitos',
              },
            }}
            setValue={setValue}
            required
            error={errors.email}
            onTypeValidation
          />
        </div>
        <div className="m-where__content__input">
          <Input
            label={contentInfo.referencias[5].nombre}
            name="cellphone"
            type="number"
            placeholder={contentInfo.referencias[5].subtitulo}
            register={register}
            square
            maxLength="10"
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
              pattern: {
                value: /^([0-9])+$/,
                message: 'No se permiten caracteres especiales o valores negativos',
              },
              maxLength: {
                value: 10,
                message: 'El número de celular no debe superar los 10 dígitos',
              },
              minLength: {
                value: 10,
                message: 'El número de celular debe tener al menos 10 dígitos',
              },
            }}
            setValue={setValue}
            required
            error={errors.cellphone}
            onTypeValidation
          />
        </div>
      </div>
      {/* <div className="m-where__note">
                {contentInfo &&
                    documentToReactComponents(
                        JSON.parse(contentInfo.descripcion.raw)
                    )}
            </div> */}
    </div>
  );
};

export default WhereConfirmation;
